import { KeyValueRow, KeyValueTable } from '@/design-system/components/ui';

import { Trigger } from '../../domain';

interface Props {
  trigger: Trigger;
}

export function PolymarketTradeVolumeTriggerFullDetails({ trigger }: Props) {
  const conditionId = trigger.context?.conditionId || '-';

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Market ID (Condition ID)" value={conditionId} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
}
